import React, { useState } from 'react';
import Sidebar from './Sidebar';
import { useTheme } from '../contexts/ThemeContext';
import { Sun, Moon, Menu, X } from 'lucide-react';

const Layout = ({ children }) => {
  const { isDarkMode, toggleTheme } = useTheme();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className={`app-container ${isDarkMode ? 'dark' : 'light'}`}>
      {/* Mobile Menu Toggle */}
      <button
        onClick={() => setSidebarOpen(!sidebarOpen)}
        className="mobile-menu-toggle"
        data-testid="mobile-menu-toggle"
      >
        {sidebarOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Sidebar */}
      <div className={`sidebar ${sidebarOpen ? 'mobile-open' : ''}`}>
        <Sidebar onLinkClick={() => setSidebarOpen(false)} />
      </div>

      {/* Mobile Overlay */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Main Content */}
      <main className={`main-content ${isDarkMode ? 'dark-theme' : 'light-theme'}`}>
        {/* Theme Toggle Button */}
        <div className="fixed top-4 right-4 z-30">
          <button
            onClick={toggleTheme}
            data-testid="theme-toggle"
            className={`p-3 rounded-lg transition-all duration-200 ${
              isDarkMode 
                ? 'bg-[hsl(220_6%_12%)] border border-[hsl(215_10%_22%)] text-[#F59E0B] hover:bg-[hsl(215_8%_20%)]' 
                : 'bg-white border border-gray-200 text-gray-700 hover:bg-gray-100 shadow-sm'
            }`}
            title={isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
          >
            {isDarkMode ? <Sun size={20} /> : <Moon size={20} />}
          </button>
        </div>

        {children}
      </main>
    </div>
  );
};

export default Layout;
